import React from 'react';
import PropTypes from 'prop-types';
import Typography from "../../../components/Generic/Typography";
import { FAQ_TITLE } from '../../../constants/global';

const FAQBlock = ({ faqItems }) => {
    const [openIndexes, setOpenIndexes] = React.useState([]);
    const answerRefs = React.useRef([]);

    const toggleFAQ = index => {
        setOpenIndexes(prev => {
            const newOpen = [...prev];
            newOpen[index] = !newOpen[index];
            return newOpen;
        });
        setTimeout(() => {
            if (answerRefs.current[index] && !openIndexes[index]) {
                const answerElement = answerRefs.current[index];
                if (answerElement) {
                    answerElement.focus();
                    // Scroll into view for high zoom and mobile/tablet
                    answerElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            }
        }, 150);
    };

 if(!faqItems || faqItems.length === 0) {
    return null;
  }

  const faqList = faqItems?.length > 0 ? faqItems : [];

      return (
        <div
            className="w-full gap-5 flex flex-col relative my-20 px-30"
            role="application"
            aria-label="Perguntas Frequentes"
            onKeyDown={e => {
                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }}
        >
            <div className="py-4 mb-20">
                <h3 className="uppercase faqTitle md:text-39 xl:text-39 text-black font-BebasNeueBold text-center tracking-1.74 md:tracking-4">
                    {FAQ_TITLE}
                </h3>
            </div>
            <div className="flex flex-col">
                {faqList?.map((faq, index) => (
                    <div
                        key={index}
                        className="border-b border-greyDarker border-b-1 md:px-10 py-10 md:py-18"
                    >
                        <button
                            className="w-full faqQuestion flex justify-between items-center py-4 text-left focus:outline-none"
                            onClick={() => toggleFAQ(index)}
                            aria-expanded={openIndexes[index] ? "true" : "false"}
                            onKeyDown={e => {
                                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }}
                        >
                            <Typography
                                component="span"
                                className="text-md font-semibold"
                                dangerouslySetInnerHTML={{ __html: (faq.question) }}
                            />
                            <span className="faqSymbol ml-4 transition-transform duration-300" aria-hidden="true">
                                {openIndexes[index] ? (
                                    <span className="font-bold">
                                        -
                                    </span>
                                ) : (
                                    <span className="font-bold">
                                        +
                                    </span>
                                )}
                            </span>
                        </button>
                        <div
                            className={`overflow-hidden transition-all text-16 duration-300 ${
                                openIndexes[index]
                                    ? "max-h-550 md:max-h-250 opacity-100"
                                    : "max-h-0 opacity-0"
                            }`}
                            style={!openIndexes[index] ? { visibility: 'hidden', height: '0', overflow: 'hidden' } : {}}
                            aria-hidden={!openIndexes[index] ? "true" : "false"}
                            tabIndex={openIndexes[index] ? 0 : -1}
                            ref={el => answerRefs.current[index] = el}
                            onKeyDown={e => {
                                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }}
                        >
                            <Typography
                                component="p"
                                className="pt-8 md:pt-12 pb-4 px-1 leading-20"
                                dangerouslySetInnerHTML={{ __html: (faq.answer) }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

FAQBlock.propTypes = {
  faqItems: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
    })
  ),
};
export default FAQBlock;
